<script>
import { THIRD_LEVEL_MENU, FUNCTION_LIST } from '@/components/pc/radio/ipradio/config/BCconstants.js'

export default {
  name: 'MenuSettingsViewer',

  props: {
      first: {
          type: String,
          required: true
      },
      second: {
          type: String,
          required: true
      },
      setting: {
          type: Object,
          required: false,
      },
  },

  computed: {
    firstLevel() { return this.first },
    secondLevel() { return this.second },

    // 元コードの変数名に合わせて "thridLevel"
    thridLevel() {
      const lvl2 = (THIRD_LEVEL_MENU[this.firstLevel] || {})[this.secondLevel] || []
      return lvl2[0] ? lvl2[0].name : ''
    },
    thirdLevelLabel() {
      const lvl2 = (THIRD_LEVEL_MENU[this.firstLevel] || {})[this.secondLevel] || []
      return lvl2[0] ? lvl2[0].label : ''
    },

    superlockList() {
      const src =
        (this.setting && this.setting[this.firstLevel] && this.setting[this.firstLevel][this.secondLevel] && this.setting[this.firstLevel][this.secondLevel][this.thridLevel]) || []
      return src.map((val) => {
        const found = FUNCTION_LIST.find((f) => f.value === val)
        return { label: found ? found.label : String(val) }
      })
    },
  },
}
</script>

<template>
  <div class="superlock-view">
    <div class="menuSettingsWrapper">
      <el-table class="growTable" :data="superlockList">
        <el-table-column prop="label" :label="thirdLevelLabel" />
      </el-table>
    </div>
  </div>
</template>

<style scoped>
.menuSettingsWrapper {
  display: grid;
  grid-template-rows: auto 1fr;
  height: calc(100vh - 157px);
  overflow: hidden;
}

.growTable {
  display: block;
  height: auto;
  min-height: calc((100vh - 157px) / 3);
  max-height: calc((100vh - 157px) / 2);
  overflow-y: auto;
}
</style>
